import React, { useEffect, useState } from "react";
import { QuestionsIF } from "./QuestionsIF";
import { GenderValue } from "shared";
import { styled } from "@mui/material";
import { AnswerButton, SelectionType } from "../uiControllers/AnswerButton";
import { DocQuestion } from "./DocQuestion";
import {
  OptionsWrapper,
  QuestionOptionsContainer,
} from "./layout/questionOptionsContainer";
import { useTranslate } from "../../hooks/useTranslate";
import {
  SearchComponent,
  UserEnterSymptomsMode,
} from "../search/searchComponent";
import { NoMatchingResultsDisclaimer } from "./noMatchingResultsDisclaimer";
import { useNavigation } from "../../state/navigationContext";
import { ThreeDotsLoader } from "fe-web-components/loader/threeDotsLoader";
import { PatientColorMap } from "../../layout/patientColorMap";
import { FeatureWithName } from "fe-web-components/autocomplete";

//region [[ Styles ]]
const OpenQuestionView = styled("div")(({ theme }) => ({
  display: "flex",
  width: "100%",
  flexDirection: "column",
}));

const OptionButtons = styled(OptionsWrapper)(({ theme }) => ({
  "& .no-button": {
    marginRight: "10px",
  },
}));
//endregion [[ Styles ]]

//region [[ Props ]]
export interface OpenQuestionProps extends QuestionsIF {
  gender: GenderValue;
  canSkip: boolean;
  prefixText?: string;
  userEnterSymptom?: UserEnterSymptomsMode;
}
//endregion [[ Props ]]

const categories = [
  // KahunCategories.SIGNS_SYMPTOMS,
  // KahunCategories.KAHUN_SYMPTOMS,
  // KahunCategories.SIGN,
  // KahunCategories.KAHUN_LAB_DISORDERS,
  // KahunCategories.VITAL_SIGNS,
];

export const OpenQuestion = (props: OpenQuestionProps) => {
  const [selected, setSelected] = useState("");

  const [didAnswerYes, setDidAnswerYes] = useState<boolean>(false);

  const { translate } = useTranslate();

  const isAnswered = props.answer !== null && props.answer !== undefined;
  const [loading, setLoading] = useState(false);

  const { setViewChanged } = useNavigation();

  const [showContinueQuestion, setShowContinueQuestion] = useState<boolean>(
    false,
  );

  useEffect(() => {
    if (!isAnswered) setSelected("");
  }, [isAnswered]);

  const onChange = (event, featureWithName: FeatureWithName) => {
    if (featureWithName?.value) {
      const qualifiedFeature = featureWithName.value;
      props.onAnswer([qualifiedFeature]);

      // if (qualifiedFeature.feature?.alias) {
      //   const { feature } = qualifiedFeature;
      //   FeatureAliasMapper.addAlias(feature.shortname, feature.alias);
      // }

      setSelected(featureWithName.name);
      setShowContinueQuestion(false);
    }
  };

  const onUserSymptomSent = () => {
    setShowContinueQuestion(true);
    setViewChanged(true);
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setViewChanged(true);
    }, 200);
  };

  const hasPrefixText =
    props.prefixText && props.prefixText !== "NO_MATCHING_DD";

  const askYesNoBeforeShowingSearch =
    !didAnswerYes && !isAnswered && props.canSkip;

  const showSearchComponent = !isAnswered && (didAnswerYes || !props.canSkip);
  return (
    <OpenQuestionView>
      {hasPrefixText && (
        <DocQuestion
          text={translate(props.prefixText)}
          miniView={props.miniView}
        />
      )}
      {props.prefixText === "NO_MATCHING_DD" && <NoMatchingResultsDisclaimer />}
      {askYesNoBeforeShowingSearch && (
        <QuestionOptionsContainer>
          <OptionButtons>
            <AnswerButton
              gender={props.gender}
              type={SelectionType.YES}
              selected={didAnswerYes}
              onClick={() => {
                setDidAnswerYes(true);
              }}
            />
            <AnswerButton
              className={"no-button"}
              gender={props.gender}
              type={SelectionType.NO}
              selected={!selected && isAnswered}
              onClick={() => {
                props.onAnswer([], true);
                console.log("no");
              }}
            />
          </OptionButtons>
        </QuestionOptionsContainer>
      )}
      {showSearchComponent && (
        <SearchComponent
          onChange={onChange}
          disabled={isAnswered}
          selected={selected}
          searchOptions={{ categories, patientFacing: true }}
          userEnterSymptom={
            props.userEnterSymptom || UserEnterSymptomsMode.TELL_US
          }
          onUserSymptomSent={onUserSymptomSent}
        />
      )}

      {loading && <ThreeDotsLoader color={PatientColorMap.Primary} />}

      {!loading && showContinueQuestion && !isAnswered && (
        <>
          <DocQuestion
            text={translate("CONTINUE_QUESTION_AFTER_ENTER_SYMPTOM")}
            miniView={props.miniView}
          />
          <SearchComponent
            onChange={onChange}
            disabled={isAnswered}
            selected={selected}
            userEnterSymptom={UserEnterSymptomsMode.TELL_US}
            searchOptions={{ categories, patientFacing: true }}
          />
        </>
      )}
    </OpenQuestionView>
  );
};
